import { Pipe, PipeTransform } from '@angular/core';

/**
 * CB Type Label Pipe
 * 將 cbType 數字值轉換為對應的標籤文字
 * 使用方式: {{ item.cbType | cbTypeLabel }}
 */
@Pipe({
  name: 'cbTypeLabel'
})
export class CbTypeLabelPipe implements PipeTransform {
  private readonly cbTypeMap = new Map<number, string>([
    [1, '1.出貨'],
    [2, '2.進貨'],
    [3, '3.報關'],
    [4, '4.出貨+報關'],
    [5, '5.進貨+報關'],
    [6, '6.本地']
  ]);

  transform(value: number | null | undefined): string {
    if (value === null || value === undefined) {
      return '';
    }
    return this.cbTypeMap.get(value) || String(value);
  }
}
